<div class="h-11 flex items-center text-gray-400"><slot></slot></div>